import React, { useEffect, useState } from "react";
import "./profile.scss";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Stack,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import authStore from "../../../store/authStore";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import userActivePage from "../../../store/userActivePage";

import user_img from "../../../assets/user_img.jpg";
// Icons
import { FaAddressCard } from "react-icons/fa";
import { FaBoxesStacked } from "react-icons/fa6";
import { IoLogOut, IoLockClosed } from "react-icons/io5";
import { BiSolidCoupon } from "react-icons/bi";
import { LoadingButton } from "@mui/lab";

const profileList = [
  {
    id: 1,
    pageName: "Address",
    to: "/user/address",
    icon: <FaAddressCard className="icon" />,
  },
  {
    id: 2,
    pageName: "Coupon",
    to: "/user/coupon",
    icon: <BiSolidCoupon className="icon" />,
  },
  {
    id: 3,
    pageName: "My Orders",
    to: "/user/my-orders",
    icon: <FaBoxesStacked className="icon" />,
  },
  {
    id: 4,
    pageName: "Forgot Password",
    to: "/user/forgot-password",
    icon: <IoLockClosed className="icon" />,
  },
];

const Profile = () => {
  const AuthStore = authStore();
  const UserActivePage = userActivePage();
  const navigate = useNavigate();

  useEffect(() => {
    UserActivePage.setIsActive({ setPage: "" });
    window.scrollTo({ top: 0 });
  }, []);

  const [open, setOpen] = useState(false);
  const [signOutLoading, setSignOutLoading] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!signOutLoading) {
      setOpen(false);
    }
  };

  const signOutOnClick = async () => {
    setSignOutLoading(true);
    await AuthStore.signOut();
    setSignOutLoading(false);
    navigate("/", { replace: true });
  };

  return (
    <div className="profile">
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <DialogTitle id="alert-dialog-title">
          <p>Sign Out?</p>
        </DialogTitle>
        <DialogContent>
          <p>Are you sure want to sign out?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <LoadingButton loading={signOutLoading} onClick={signOutOnClick}>
            Sign Out
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Stack spacing={2} className="stack">
        {/* <p className="profile-title">Profile</p> */}
        <Stack spacing={2} direction="row" className="user-profile-view">
          <img src={user_img} alt="user-img" className="user-image" />
          <Stack className="user-details" spacing={2}>
            <div>
              <p className="user-name">
                {AuthStore.myUser.firstName} {AuthStore.myUser.lastName}
              </p>
              <p className="user-email">{AuthStore.myUser.email}</p>
            </div>
            <div className="btn">
              <Link to="/user/manage-account" className="link">
                Edit Profile <EditRoundedIcon className="icon" />
              </Link>
            </div>
          </Stack>
        </Stack>
        <Stack spacing={2} className="profile-options">
          {profileList.map((item) => (
            <Link to={item.to} className="option" key={item.id}>
              <p>{item.pageName}</p>
              {item.icon}
            </Link>
          ))}

          <Divider />

          <Link
            // onClick={async () => {
            //   await AuthStore.signOut();
            //   navigate("/", { replace: true });
            // }}
            onClick={handleClickOpen}
            className="option"
          >
            <p>Sign Out</p>
            <IoLogOut className="icon" />
          </Link>
        </Stack>
      </Stack>
    </div>
  );
};

export default Profile;
